import useScrollProgress from "./useScrollProgress";

const HABITS = ["planejar o dia", "exercício", "cardio", "leitura"];

/**
 * seção sticky: conforme o usuário rola, os 4 hábitos vão sendo "marcados"
 * como check-in, um por um, simulando o ritual diário no app.
 */
const HabitsScroll = () => {
  const [sectionRef, progress] = useScrollProgress();

  // reserva ~15% do progresso no início e no fim pra respiro
  const eased = Math.min(1, Math.max(0, (progress - 0.12) / 0.76));
  const done = Math.min(HABITS.length, Math.floor(eased * (HABITS.length + 1)));
  const allDone = done === HABITS.length;

  return (
    <section ref={sectionRef} className="relative h-[320vh]">
      <div className="sticky top-0 flex h-svh flex-col items-center justify-center px-6">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-black/35">
          o ritual diário
        </span>
        <h2 className="mt-4 text-center text-3xl font-extrabold tracking-[-0.03em] sm:text-5xl">
          4 hábitos. todo dia.
        </h2>

        <ul className="mt-10 w-full max-w-sm space-y-4 sm:mt-12 sm:space-y-5">
          {HABITS.map((habit, i) => {
            const checked = i < done;
            return (
              <li
                key={habit}
                className={`flex items-center gap-4 rounded-2xl border px-5 py-4 transition-all duration-300 sm:px-6 sm:py-5 ${
                  checked
                    ? "border-black bg-black text-white"
                    : "border-black/15 bg-white text-black"
                }`}
              >
                <span
                  className={`flex h-7 w-7 flex-none items-center justify-center rounded-full border transition-colors duration-300 ${
                    checked ? "border-white/40" : "border-black/25"
                  }`}
                >
                  <svg
                    viewBox="0 0 16 16"
                    fill="none"
                    className={`e21-check h-3.5 w-3.5 ${checked ? "is-done" : ""}`}
                  >
                    <path
                      d="M3 8.5 6.5 12 13 4.5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="e21-serif text-xl sm:text-2xl">{habit}</span>
              </li>
            );
          })}
        </ul>

        <div className="mt-8 flex flex-col items-center gap-2">
          <span className="font-mono text-sm tabular-nums text-black/40">
            {done}/4
          </span>
          <p
            className={`text-base font-bold tracking-[-0.02em] transition-opacity duration-500 sm:text-lg ${
              allDone ? "opacity-100" : "opacity-0"
            }`}
          >
            é isso. todo dia. 21 dias.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HabitsScroll;
